/* eslint-disable react-hooks/rules-of-hooks */
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ImportOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Input,
  Modal,
  Popconfirm,
  notification,
  Select,
  Tooltip,
  Typography,
  Upload,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import ZKLib from "node-zklib";
import React, { useCallback, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import excel from "xlsx";
import { Env } from "../../../styles";
import AppTable from "../../atoms/AppTable";
import "./style.css";
const { Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

const IMPORT_HEADERS = [
  "user_id",
  "events_datetime",
  "device_id",
  "device_ip",
  "device_name",
  "event_type",
];

const HEADER_ALIASES = {
  user_id: ["user_id", "userid", "user", "الرقم الوظيفي", "رقم الموظف"],
  events_datetime: [
    "events_datetime",
    "datetime",
    "date time",
    "date",
    "التاريخ والوقت",
    "التاريخ",
  ],
  device_id: ["device_id", "رقم الجهاز"],
  device_ip: ["device_ip", "ip", "عنوان الآيبي", "عنوان الايبي", "عنوان ip"],
  device_name: ["device_name", "اسم الجهاز"],
  event_type: ["event_type", "نوع الحدث", "النوع"],
};

const normalizeHeader = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const findColumnIndex = (headerRow, field, fallback) => {
  const aliases = HEADER_ALIASES[field] || [];
  const index = (headerRow || []).findIndex((cell) => {
    const header = normalizeHeader(cell);
    return aliases.some((alias) => {
      const normalizedAlias = normalizeHeader(alias);
      return header === normalizedAlias || header.includes(normalizedAlias);
    });
  });
  return index >= 0 ? index : fallback;
};

const isHeaderRow = (row) => {
  if (!row?.length) return false;
  const joined = row.map((cell) => normalizeHeader(cell)).join(" ");
  return (
    joined.includes("user") ||
    joined.includes("الرقم") ||
    joined.includes("events_datetime") ||
    joined.includes("التاريخ")
  );
};

const formatEventDateTime = (value) => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
  }
  if (typeof value === "number") {
    const parsed = excel.SSF.parse_date_code(value);
    if (parsed) {
      const month = String(parsed.m).padStart(2, "0");
      const day = String(parsed.d).padStart(2, "0");
      const hour = String(parsed.H).padStart(2, "0");
      const minute = String(parsed.M).padStart(2, "0");
      const second = String(parsed.S).padStart(2, "0");
      return `${parsed.y}-${month}-${day} ${hour}:${minute}:${second}`;
    }
  }
  return String(value || "").trim();
};

const normalizeEventType = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const text = String(value).trim();
  if (["0", "دخول", "in", "check-in", "checkin"].includes(text.toLowerCase())) {
    return "0";
  }
  if (["1", "خروج", "out", "check-out", "checkout"].includes(text.toLowerCase())) {
    return "1";
  }
  return text;
};

const getCellValue = (row, index) => {
  if (index === undefined || index === null || index < 0) return "";
  const value = row?.[index];
  if (value === undefined || value === null || value === "") return "";
  return value;
};

export default function events() {
  const [cookies, setCookie, removeCookie] = useCookies(["userId"]);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [startVac, setStartVac] = useState("");
  const [type, setType] = useState(null);
  const [start, setStart] = useState(
    new Date(new Date().setDate(new Date().getDate() - 30))
      .toISOString()
      .slice(0, 10)
  );
  const [end, setEnd] = useState(new Date().toISOString().slice(0, 10));
  const [endVac, setEndVac] = useState("");
  const [notes, setNotes] = useState("");
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(true);

  const [uploading, setUploading] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [connected, setConnected] = useState(true);
  const normalizedFilteredInfo = filteredInfo || {};
  const user = cookies.user;
  const fetchEvents = useCallback(() => {
    setLoad(true);
    axios
      .get(Env.HOST_SERVER_NAME + "events" + "/" + start + "/" + end)
      .then((response) => {
        setData(response.data);
        setLoad(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [start, end]);
  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  const handleTypeChange = (e) => {
    setType(e);
  };
  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };
  const onRangeChange = (all, dates) => {
    setStartVac(dates[0]);
    setEndVac(dates[1]);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    var values = {
      user_id: cookies.user.user_id,
      startDate: startVac,
      endDate: endVac,
      type: type,
      note: notes,
    };
    axios
      .post(Env.HOST_SERVER_NAME + `add-task`, values)
      .then(function (response) {
        if (response.statusText == "OK") {
          alert("تم إرسال الإجازة بنجاح");
        }
      })
      .catch(function (error) {
        alert("error..");
        console.log(error);
      });
    setIsModalVisible(false);
  };
  const notesChange = (e) => {
    setNotes(e.target.value);
  };
  const getDatePart = (dt) => (dt?.includes(" ") ? dt.split(" ")[0] : "-");
  const getTimePart = (dt) => (dt?.includes(" ") ? dt.split(" ")[1] : dt) || "-";
  const getEventTypeLabel = (event_type) => {
    if (event_type === null || event_type === undefined || event_type === "") {
      return "-";
    }
    const eventTypes = {
      0: "دخول",
      1: "خروج",
    };
    return eventTypes[event_type] || `نوع ${event_type}`;
  };
  const getStatusLabel = (record, fallbackStatus) => {
    const statusCode = record?.device_status_code;
    const statusText = record?.device_status || fallbackStatus;
    if (statusCode === 0 || statusText === "مرفوضة") return "مرفوضة";
    if (statusCode === 1 || statusText === "مقبولة") return "مقبولة";
    return "-";
  };
  const buildColumnFilters = (accessor) => {
    const uniqueValues = Array.from(
      new Set((data || []).map((item) => accessor(item)).filter(Boolean))
    );
    return uniqueValues.map((value) => ({ text: value, value }));
  };
  const SearchableFilterDropdown = ({
    options,
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const [searchText, setSearchText] = useState("");
    const availableOptions = options || [];
    const allValues = availableOptions.map((option) => option.value);
    const selectedValues = selectedKeys || [];
    const isAllSelected =
      allValues.length > 0 &&
      allValues.every((value) => selectedValues.includes(value));
    const filteredOptions = availableOptions.filter((option) =>
      String(option.text || "")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );

    return (
      <div style={{ padding: 8, width: 260 }}>
        <Input
          placeholder="البحث..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ marginBottom: 8 }}>
          <Checkbox
            checked={isAllSelected}
            onChange={(e) => {
              if (e.target.checked) setSelectedKeys(allValues);
              else setSelectedKeys([]);
            }}
            style={{ fontWeight: "bold" }}
          >
            تحديد الكل
          </Checkbox>
        </div>
        <div style={{ maxHeight: 220, overflow: "auto", marginBottom: 8 }}>
          {filteredOptions.map((option) => (
            <div key={option.value} style={{ marginBottom: 4 }}>
              <Checkbox
                checked={selectedValues.includes(option.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedValues, option.value]);
                  } else {
                    setSelectedKeys(
                      selectedValues.filter((key) => key !== option.value)
                    );
                  }
                }}
              >
                {option.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "left" }}>
          <Button
            size="small"
            style={{ marginLeft: 8 }}
            onClick={() => {
              clearFilters?.();
              setSelectedKeys([]);
              confirm();
            }}
          >
            مسح
          </Button>
          <Button type="primary" size="small" onClick={() => confirm()}>
            تأكيد
          </Button>
        </div>
      </div>
    );
  };
  const getSearchableFilterProps = (columnKey, accessor) => {
    const options = buildColumnFilters(accessor);
    return {
      filteredValue: normalizedFilteredInfo[columnKey] || null,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <SearchableFilterDropdown
          options={options}
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
        />
      ),
      onFilter: (value, record) => accessor(record) === value,
    };
  };
  const columns = [
    {
      title: "اسم الموظف",
      dataIndex: "fullname",
      key: "fullname",
      ellipsis: true,
      ...getSearchableFilterProps("fullname", (record) => record?.fullname || "-"),
    },
    {
      title: "الرقم الوظيفي",
      dataIndex: "user_id",
      key: "user_id",
      ellipsis: true,
      ...getSearchableFilterProps("user_id", (record) =>
        String(record?.user_id || "-")
      ),
    },
    {
      title: "التاريخ",
      dataIndex: "events_datetime",
      key: "events_datetime",
      ellipsis: true,
      ...getSearchableFilterProps("events_datetime", (record) =>
        getDatePart(record?.events_datetime)
      ),
      render: (dt) => getDatePart(dt),
    },
    {
      title: "الوقت",
      dataIndex: "events_datetime",
      key: "events_datetime_time",
      ellipsis: true,
      ...getSearchableFilterProps("events_datetime_time", (record) =>
        getTimePart(record?.events_datetime)
      ),
      render: (dt) => getTimePart(dt),
    },
    {
      title: "نوع الحدث",
      dataIndex: "event_type",
      key: "event_type",
      ellipsis: true,
      ...getSearchableFilterProps("event_type", (record) =>
        getEventTypeLabel(record?.event_type)
      ),
      render: (event_type) => getEventTypeLabel(event_type),
    },
    {
      title: "اسم الجهاز",
      dataIndex: "device_name",
      key: "device_name",
      ellipsis: true,
      ...getSearchableFilterProps("device_name", (record) =>
        record?.device_name || "-"
      ),
      render: (device_name) => device_name || "-",
    },
    {
      title: "عنوان الآيبي",
      dataIndex: "device_ip",
      key: "device_ip",
      ellipsis: true,
      ...getSearchableFilterProps("device_ip", (record) => record?.device_ip || "-"),
      render: (device_ip) => device_ip || "-",
    },
    {
      title: "رقم الجهاز",
      dataIndex: "device_id",
      key: "device_id",
      ellipsis: true,
      ...getSearchableFilterProps("device_id", (record) =>
        String(record?.device_id || "-")
      ),
      render: (device_id) => device_id || "-",
    },
    {
      title: "حالة البصمة",
      dataIndex: "device_status",
      key: "device_status",
      ellipsis: true,
      ...getSearchableFilterProps("device_status", (record) =>
        getStatusLabel(record, record?.device_status)
      ),
      render: (status, record) => {
        const statusLabel = getStatusLabel(record, status);

        if (statusLabel === "مرفوضة") {
          return (
            <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>
              ❌ مرفوضة
            </span>
          );
        } else if (statusLabel === "مقبولة") {
          return (
            <span style={{ color: "#52c41a", fontWeight: "bold" }}>
              ✅ مقبولة
            </span>
          );
        }
        return "-";
      },
    },
    {
      title: "الإجراءات",
      key: "actions",
      width: 120,
      fixed: "right",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            onClick={() => openEditModal(record)}
          />
          <Popconfirm
            title="تأكيد الحذف"
            description="هل أنت متأكد من حذف هذا السجل؟"
            okText="حذف"
            cancelText="إلغاء"
            onConfirm={() => handleDeleteEvent(record)}
          >
            <Button danger shape="circle" icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
  ];
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const testConnection = async () => {
    // ZKLib = require('./zklib')
    let zkInstance = new ZKLib("192.168.0.201", 4370, 10000, 4000);
    try {
      // Create socket to machine
      await zkInstance.createSocket();
      // Get general info like logCapacity, user counts, logs count
      // It's really useful to check the status of device
      console.log(await zkInstance.getInfo());
    } catch (e) {
      console.log(e);
      if (e.code === "EADDRINUSE") {
      }
    }
  };
  const changeRange = (all, date) => {
    setStart(date[0]);
    setEnd(date[1]);
  };
  const changeMonth = (value) => {
    if (!value) return;
    setStart(dayjs(value).startOf("month").format("YYYY-MM-DD"));
    setEnd(dayjs(value).endOf("month").format("YYYY-MM-DD"));
  };
  const openNotification = (placement, text) => {
    notification.success({
      message: text,
      placement,
      duration: 10,
    });
  };
  const openErrorNotification = (message, description) => {
    notification.error({
      message,
      description,
      placement: "bottomLeft",
      duration: 6,
    });
  };
  const openEditModal = (record) => {
    setEditingEvent({
      id: record.id,
      user_id: record.user_id || "",
      events_datetime: record.events_datetime || "",
      device_id: record.device_id || "",
      device_ip: record.device_ip || "",
      device_name: record.device_name || "",
      event_type:
        record.event_type === null || record.event_type === undefined
          ? ""
          : String(record.event_type),
    });
    setEditModalVisible(true);
  };
  const updateEditingField = (field, value) => {
    setEditingEvent((prev) => ({ ...prev, [field]: value }));
  };
  const handleEditSave = () => {
    if (!editingEvent?.id) return;
    if (!editingEvent.user_id || !editingEvent.events_datetime) {
      openErrorNotification("بيانات ناقصة", "الرقم الوظيفي وتاريخ الحدث مطلوبان");
      return;
    }
    setEditLoading(true);
    axios
      .put(Env.HOST_SERVER_NAME + `events/${editingEvent.id}`, {
        user_id: editingEvent.user_id,
        events_datetime: editingEvent.events_datetime,
        device_id: editingEvent.device_id || null,
        device_ip: editingEvent.device_ip || null,
        device_name: editingEvent.device_name || null,
        event_type:
          editingEvent.event_type === "" ? null : Number(editingEvent.event_type),
      })
      .then(() => {
        setEditModalVisible(false);
        setEditingEvent(null);
        openNotification("bottomLeft", "تم تعديل السجل بنجاح");
        fetchEvents();
      })
      .catch((error) => {
        openErrorNotification(
          "فشل تعديل السجل",
          error.response?.data?.message || "تعذر الاتصال بالخادم"
        );
      })
      .finally(() => {
        setEditLoading(false);
      });
  };
  const handleDeleteEvent = (record) => {
    if (!record?.id) return;
    axios
      .delete(Env.HOST_SERVER_NAME + `events/${record.id}`)
      .then(() => {
        openNotification("bottomLeft", "تم حذف السجل بنجاح");
        fetchEvents();
      })
      .catch((error) => {
        openErrorNotification(
          "فشل حذف السجل",
          error.response?.data?.message || "تعذر الاتصال بالخادم"
        );
      });
  };
  const downloadImportTemplate = () => {
    const dataSheet = excel.utils.aoa_to_sheet([
      IMPORT_HEADERS,
      ["101", "2026-08-29 08:00:00", "1", "192.168.1.10", "جهاز الإدارة", "0"],
      ["101", "2026-08-29 16:00:00", "1", "192.168.1.10", "جهاز الإدارة", "1"],
    ]);
    dataSheet["!cols"] = [
      { wch: 18 },
      { wch: 24 },
      { wch: 14 },
      { wch: 18 },
      { wch: 18 },
      { wch: 14 },
    ];

    const instructionsSheet = excel.utils.aoa_to_sheet([
      ["تعليمات تعبئة نموذج استيراد البصمات"],
      [""],
      ["لا تغيّر أسماء الأعمدة في ورقة البصمات، وعبّئ الصفوف تحتها."],
      [""],
      ["العمود في الملف", "المعنى", "مطلوب؟", "طريقة التعبئة"],
      ["user_id", "الرقم الوظيفي", "مطلوب", "رقم الموظف كما هو مسجل في النظام"],
      [
        "events_datetime",
        "التاريخ والوقت",
        "مطلوب",
        "YYYY-MM-DD HH:mm:ss مثل 2026-08-29 08:00:00",
      ],
      ["device_id", "رقم الجهاز", "اختياري", "مثال: 1"],
      ["device_ip", "عنوان الآيبي", "اختياري", "مثال: 192.168.1.10"],
      ["device_name", "اسم الجهاز", "اختياري", "مثال: جهاز الإدارة"],
      ["event_type", "نوع الحدث", "اختياري", "0 أو دخول = دخول ، 1 أو خروج = خروج"],
      [""],
      ["ملاحظات"],
      ["1. استبدل صفوف المثال في ورقة البصمات ببيانات الموظفين."],
      ["2. يمكن ترك الأعمدة الاختيارية فارغة."],
      ["3. بعد التعبئة ارفع الملف من زر استيراد البصمات."],
    ]);
    instructionsSheet["!cols"] = [{ wch: 22 }, { wch: 18 }, { wch: 12 }, { wch: 70 }];

    const workbook = excel.utils.book_new();
    excel.utils.book_append_sheet(workbook, dataSheet, "البصمات");
    excel.utils.book_append_sheet(workbook, instructionsSheet, "تعليمات");
    excel.writeFile(workbook, "نموذج_استيراد_البصمات.xlsx");
  };

  const testUpload = (file) => {
    setUploading(true);
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = excel.read(bstr, { type: rABS ? "binary" : "array" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const rows = excel.utils.sheet_to_json(ws, { header: 1, defval: "" });
      const hasHeaders = isHeaderRow(rows[0]);
      const headerRow = hasHeaders ? rows[0] : [];
      const startIndex = hasHeaders ? 1 : 0;
      const columnIndexes = {
        user_id: findColumnIndex(headerRow, "user_id", 0),
        events_datetime: findColumnIndex(headerRow, "events_datetime", 1),
        device_id: findColumnIndex(headerRow, "device_id", 2),
        device_ip: findColumnIndex(headerRow, "device_ip", 3),
        device_name: findColumnIndex(headerRow, "device_name", 4),
        event_type: findColumnIndex(headerRow, "event_type", 5),
      };
      const eventsArray = [];

      for (let i = startIndex; i < rows.length; i++) {
        const row = rows[i];
        if (!row || row.every((cell) => cell === "" || cell === null || cell === undefined)) {
          continue;
        }

        const userId = String(getCellValue(row, columnIndexes.user_id) || "").trim();
        const eventDateTime = formatEventDateTime(
          getCellValue(row, columnIndexes.events_datetime)
        );
        if (!userId || !eventDateTime) continue;

        const eventObj = {
          user_id: userId,
          events_datetime: eventDateTime,
        };

        const deviceId = String(getCellValue(row, columnIndexes.device_id) || "").trim();
        const deviceIp = String(getCellValue(row, columnIndexes.device_ip) || "").trim();
        const deviceName = String(getCellValue(row, columnIndexes.device_name) || "").trim();
        const eventType = normalizeEventType(getCellValue(row, columnIndexes.event_type));

        if (deviceId) eventObj.device_id = deviceId;
        if (deviceIp) eventObj.device_ip = deviceIp;
        if (deviceName) eventObj.device_name = deviceName;
        if (eventType !== "") eventObj.event_type = eventType;

        eventsArray.push(eventObj);
      }

      if (!eventsArray.length) {
        openErrorNotification(
          "الملف غير صالح",
          "لم يتم العثور على صفوف بصمات. استخدم النموذج وعبّئ الرقم الوظيفي والتاريخ والوقت."
        );
        setUploading(false);
        return;
      }

      axios
        .post(Env.HOST_SERVER_NAME + "events-import", eventsArray)
        .then((response) => {
          console.log(response);
          setUploading(false);
          openNotification("bottomLeft", "تم الاستيراد بنجاح");
          fetchEvents();
        })
        .catch(function (error) {
          console.error("Import error:", error);
          notification.error({
            message: "فشل الاستيراد",
            description:
              error.response?.data?.message || "يوجد مشكلة في الاتصال بالسرفر!",
            placement: "bottomLeft",
            duration: 5,
          });
          setUploading(false);
        });
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);

    return false;
  };
  return (
    <Card className="eventsPage">
      <div className="discountHeader">
        {window.innerWidth <= 760 ? (
          <></>
        ) : (
          <div className="eventsMonthPicker">
            <span>اختر شهرًا : </span>
            <DatePicker
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
              defaultValue={dayjs()}
              onChange={changeMonth}
              picker="month"
            />
          </div>
        )}
        <div className="discountRange">
          <span>اختر فترة : </span>
          <RangePicker
            needConfirm={true}
            inputReadOnly={window.innerWidth <= 760}
            value={[dayjs(start, "YYYY-MM-DD"), dayjs(end, "YYYY-MM-DD")]}
            onChange={changeRange}
          />
        </div>
        <div className="eventsImportActions">
          <Tooltip title="نزّل النموذج، استبدل صفوف المثال ببيانات الموظفين، ثم ارفع الملف">
            <Button
              className="discountBtn"
              icon={<DownloadOutlined />}
              onClick={downloadImportTemplate}
            >
              تنزيل النموذج
            </Button>
          </Tooltip>
          <Upload
            accept=".xlsx, .csv"
            showUploadList={false}
            beforeUpload={(file) => {
              testUpload(file);
            }}
          >
            <Button
              loading={uploading}
              className="discountBtn"
              style={{
                display: "block",
                backgroundColor: "#0972B6",
                borderColor: "#0972B6",
              }}
              type="primary"
              icon={<ImportOutlined />}
            >
              استيراد البصمات
            </Button>
          </Upload>
        </div>
      </div>
      <Modal
        centered
        title="تقديم إجازة / مهمة"
        visible={isModalVisible}
        onOk={function () {
          handleOk();
        }}
        onCancel={function () {
          handleCancel();
        }}
      ></Modal>
      <Modal
        centered
        title="تعديل سجل بصمة"
        open={editModalVisible}
        onOk={handleEditSave}
        okText="حفظ"
        cancelText="إلغاء"
        confirmLoading={editLoading}
        onCancel={() => {
          setEditModalVisible(false);
          setEditingEvent(null);
        }}
      >
        <div style={{ display: "grid", gap: 10 }}>
          <Input
            placeholder="الرقم الوظيفي"
            value={editingEvent?.user_id}
            onChange={(e) => updateEditingField("user_id", e.target.value)}
          />
          <Input
            placeholder="التاريخ والوقت (YYYY-MM-DD HH:mm:ss)"
            value={editingEvent?.events_datetime}
            onChange={(e) => updateEditingField("events_datetime", e.target.value)}
          />
          <Input
            placeholder="رقم الجهاز"
            value={editingEvent?.device_id}
            onChange={(e) => updateEditingField("device_id", e.target.value)}
          />
          <Input
            placeholder="عنوان IP"
            value={editingEvent?.device_ip}
            onChange={(e) => updateEditingField("device_ip", e.target.value)}
          />
          <Input
            placeholder="اسم الجهاز"
            value={editingEvent?.device_name}
            onChange={(e) => updateEditingField("device_name", e.target.value)}
          />
          <Select
            allowClear
            placeholder="نوع الحدث"
            value={
              editingEvent?.event_type === "" ? undefined : editingEvent?.event_type
            }
            onChange={(value) => updateEditingField("event_type", value ?? "")}
          >
            <Option value="0">دخول</Option>
            <Option value="1">خروج</Option>
          </Select>
        </div>
      </Modal>
      <AppTable
        scroll={{ x: "1400px" }}
        loading={load}
        columns={columns}
        dataSource={data}
        onChange={handleChange}
        rowKey={(record, index) => record.id || `${record.user_id}_${index}`}
      />
    </Card>
  );
}
